module.exports = __webpack_public_path__ + "assets/10944dab16195f1704f9570609df8150.mp3";